import { render, staticRenderFns } from "./expo-matching-reply.vue?vue&type=template&id=05b20e6c"
import script from "./expo-matching-reply.vue?vue&type=script&lang=js"
export * from "./expo-matching-reply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports